import { createContext, useContext } from "react";
import { SettingEditorController } from "./settingEditorController";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SettingEditorControllerContext = createContext<SettingEditorController>(null as any);
export const useSettingEditorController = (): SettingEditorController => useContext(SettingEditorControllerContext);
